import { NUMBER_BY_LINE_ITEMS } from '@/const/gallery'

export default {
  data: () => ({
    gridOfItems: [],
  }),
  computed: {
    numberOfLines() {
      return {
        mobile: this.block.gallery_mobile
          ? this.getNumberOfLines(this.block.gallery_mobile)
          : this.numberOfLinesOnDesktop,
        desktop: this.block.gallery
          ? this.getNumberOfLines(this.block.gallery)
          : 0,
      }
    },

    gridItemPositions() {
      return this.getGridItemsPositions()
    },
  },

  methods: {
    getNumberOfLines(matrix) {
      let index = 0
      let currentLine = 0
      let numberOfLines = 0

      while (index < this.gridOfItems.length) {
        switch (matrix[currentLine]) {
          case NUMBER_BY_LINE_ITEMS.ONE:
            index += 1
            break
          case NUMBER_BY_LINE_ITEMS.TWO:
            index += 2
            break
          case NUMBER_BY_LINE_ITEMS.THREE:
            index += 3
            break
        }
        numberOfLines += 1
        currentLine += 1

        if (currentLine >= matrix.length) {
          currentLine = 0
        }
      }

      return numberOfLines
    },
    getGridLines(matrix) {
      let index = 0
      let currentLine = 0
      const gridLines = []

      while (index < this.gridOfItems.length) {
        switch (matrix[currentLine]) {
          case NUMBER_BY_LINE_ITEMS.ONE:
            index += 1
            gridLines.push(1)
            break
          case NUMBER_BY_LINE_ITEMS.TWO:
            if (index + 1 >= this.gridOfItems.length) {
              index += 1
              gridLines.push(1)
              break
            }

            index += 2
            gridLines.push(2)
            break
          case NUMBER_BY_LINE_ITEMS.THREE:
            index += 3
            gridLines.push(3)
            break
        }
        currentLine += 1

        if (currentLine >= matrix.length) {
          currentLine = 0
        }
      }

      return gridLines
    },
    getGridItemsPositions() {
      const gridItemsPositions = []
      let index = 0
      let row = 1
      let rowMobile = 1
      let column = 1
      let columnMobile = 1
      let currentLine = 0
      let currentMobileLine = 0

      while (index < this.gridOfItems.length) {
        const line = { desktop: {}, mobile: {} }
        switch (this.block.gallery[currentLine]) {
          case NUMBER_BY_LINE_ITEMS.ONE:
            line.desktop = {
              column: '1/13',
              row: `${row}/${row + 1}`,
              type: 'one-per-line',
            }

            currentLine += 1
            row += 1
            break

          case NUMBER_BY_LINE_ITEMS.TWO:
            if (index + 1 >= this.gridOfItems.length && column === 1) {
              line.desktop = {
                column: '1/13',
                row: `${row}/${row + 1}`,
                type: 'one-per-line',
              }

              currentLine += 1
              row += 1
              break
            }

            line.desktop = {
              column: `${column}/${column + 6}`,
              row: `${row}/${row + 1}`,
              type: 'two-per-line',
            }

            if (column > 6) {
              column = 1
              row += 1
              currentLine += 1
            } else {
              column += 6
            }
            break

          case NUMBER_BY_LINE_ITEMS.THREE:
            if (index + 1 >= this.gridOfItems.length && column === 1) {
              line.desktop = {
                column: '1/13',
                row: `${row}/${row + 1}`,
                type: 'one-per-line',
              }

              currentLine += 1
              row += 1
              break
            } else if (index + 2 >= this.gridOfItems.length && column === 1) {
              line.desktop = {
                column: `${column}/${column + 6}`,
                row: `${row}/${row + 1}`,
                type: 'two-per-line',
              }

              column += 6

              break
            } else if (index + 1 >= this.gridOfItems.length && column === 7) {
              line.desktop = {
                column: `${column}/${column + 6}`,
                row: `${row}/${row + 1}`,
                type: 'two-per-line',
              }

              column = 1
              row += 1
              currentLine += 1

              break
            }

            line.desktop = {
              column: `${column}/${column + 4}`,
              row: `${row}/${row + 1}`,
              type: 'three-per-line',
            }

            if (column > 8) {
              column = 1
              row += 1
              currentLine += 1
            } else {
              column += 4
            }
            break
        }

        switch (this.block.gallery_mobile[currentMobileLine]) {
          case NUMBER_BY_LINE_ITEMS.ONE:
            line.mobile = {
              column: '1/13',
              row: `${rowMobile}/${rowMobile + 1}`,
              type: 'one-per-line',
            }

            currentMobileLine += 1
            rowMobile += 1
            break

          case NUMBER_BY_LINE_ITEMS.TWO:
            if (index + 1 >= this.gridOfItems.length && columnMobile === 1) {
              line.mobile = {
                column: '1/13',
                row: `${rowMobile}/${rowMobile + 1}`,
                type: 'one-per-line',
              }

              currentMobileLine += 1
              rowMobile += 1
              break
            }

            line.mobile = {
              column: `${columnMobile}/${columnMobile + 6}`,
              row: `${rowMobile}/${rowMobile + 1}`,
              type: 'two-per-line',
            }

            if (columnMobile > 6) {
              columnMobile = 1
              rowMobile += 1
              currentMobileLine += 1
            } else {
              columnMobile += 6
            }
            break
        }

        gridItemsPositions.push(line)

        if (currentLine >= this.block.gallery.length) {
          currentLine = 0
        }

        if (currentMobileLine >= this.block.gallery_mobile.length) {
          currentMobileLine = 0
        }

        index++
      }

      return gridItemsPositions
    },
  },
}
